import { FilterTypesEnum } from '../enums/filters-types.enum';
import { FilterTypeModel } from './abstract-filter-type.model';
import { IncludeExcludeEnum } from '../enums/include-exclude.enum';

export class FilterGroupModel extends FilterTypeModel {
    key = FilterTypesEnum.group;

    currentValue;
    value;

    children: FilterTypeModel[];

    constructor(
        id: string,
        label: string,
        section?: string,
        showIncludeExclude?: boolean
    ) {
        super(id, label, section, showIncludeExclude);

        this.children = [];
    }


    // Required for `FilterTypeModel` but none of these do anytihng on Group
    cancelChanges() {}
    clear() {}
    getCurrentValue(): any[] {
        return [];
    }
    getValue(): any[] {
        return [];
    }
    removeChip() {}
    removeCurrentChip() {}
    setValue(values: any[]) {}
    setCurrentValue(value: any) {}
}
